import { render, staticRenderFns } from "./taobao_shangou_pyq.vue?vue&type=template&id=0a13ded8&scoped=true&"
import script from "./taobao_shangou_pyq.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_pyq.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_pyq.vue?vue&type=style&index=0&id=0a13ded8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a13ded8",
  null
  
)

export default component.exports